import React, { Component } from 'react'
import * as SignaturePad from 'react-signature-pad'

class Signature extends Component {
	componentDidMount() {
		this.refs[this.props.name].fromDataURL(this.props.value)
	}

	handleSignature(name) {
		let signatureName = this.refs[name]
		let data = signatureName.toDataURL("image/svg+xml")
		this.props.controlFunc(name, data)
	}

	render() {
		return (
			<div id={this.props.name}>
				<SignaturePad
					clearButton="true"
					ref={this.props.name}
					onEnd={() => this.handleSignature(this.props.name)}
				/>
			</div>
		)
	}
}

export default Signature


// WEBPACK FOOTER //
// ./src/components/Fields/Signature.js